import { apiFetch } from './api';

const apiUrl = import.meta.env.VITE_API_URL;

/** Aba Parâmetros de Minhas empresas: uma linha por empresa, lida e gravada inteira. */
export interface ParametrosEmpresa {
    usaTarefasPadrao: boolean;
    chaveTrilhoBiblioteca: string | null;
    /** A mensagem enviada pelo chat sai no WhatsApp com "*Nome:*" na primeira linha. */
    mostrarNomeDoAtendente: boolean;
    /** A empresa já tem um trilho? Sem ele, ligar o parâmetro abre a biblioteca antes de gravar. */
    temTrilho: boolean;
    etapasComTarefa: number;
    diasUteisCadastrados: boolean;
}

interface ApiResponse<T> { sucesso: boolean; mensagem: string; dados: T; }

export const ParametrosEmpresaService = {
    async ler(): Promise<ParametrosEmpresa> {
        const res = await apiFetch(`${apiUrl}/api/Empresa/Parametros`);
        const r: ApiResponse<ParametrosEmpresa> = await res.json();
        if (!r.sucesso) throw new Error(r.mensagem || 'Erro ao ler os parâmetros.');
        return r.dados;
    },

    async gravar(dados: { usaTarefasPadrao: boolean; mostrarNomeDoAtendente: boolean }): Promise<ApiResponse<ParametrosEmpresa>> {
        const res = await apiFetch(`${apiUrl}/api/Empresa/Parametros`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dados),
        });
        return res.json();
    },
};
